module.exports = __webpack_public_path__ + "media/images/customSegments-43d4ebd67d33873e753348ca5fbe359c79842505cd184ceb2fb16003d66dde23.svg";